// iPadOS 13+ по умолчанию представляется десктопным Mac (UA «Macintosh»),
// отличается только наличием тач-точек.
export function isIOS(): boolean {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent
  if (/iPad|iPhone|iPod/.test(ua)) return true
  return /Macintosh|Mac OS X/.test(ua) && navigator.maxTouchPoints > 1
}

// Выбор устройства вывода живёт на setSinkId: без него (Safari, Firefox по
// умолчанию) селект динамиков был бы кнопкой-обманкой — звук всё равно пойдёт
// туда, куда его отправила система.
export function supportsAudioOutputSelection(): boolean {
  return typeof HTMLMediaElement !== 'undefined' && 'setSinkId' in HTMLMediaElement.prototype
}

// WebAudio-микшер включаем только там, где без него нет персональной громкости:
// iOS игнорирует HTMLMediaElement.volume, и регулятор был бы мёртвым. На
// десктопе он не нужен и вреден — ломает выбор устройства вывода
// (switchDevice('audiooutput') адресует элементы, а не AudioContext).
export function usesWebAudioMix(): boolean {
  return isIOS()
}
